import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/getPOI'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class getPOIStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "getPOIStore",
			variables: true,
		})
	}
}

export async function load_getPOI(params) {
  await initClient()

	const store = new getPOIStore()

	await store.fetch(params)

	return {
		getPOI: store,
	}
}
